<template>
  <b-modal
    class="modal-trial-to-basic"
    ref="modal"
    size="lg"
    :title="'Ops!'"
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    @hidden="onHidden"
    header-bg-variant="quinary"
  >
    <div>
      <p class="bg-quinary text-center text-white m-0 line-height">
        <b>{{ labels.text1 }}</b> <br />
        <small>{{ labels.text2 }}</small>
      </p>

      <div
        id="carouselExampleIndicators"
        class="carousel slide"
        data-ride="carousel"
      >
        <div class="carousel-inner">
          <div class="carousel-item" :class="{ active: active === 1 }">
            <div class="image-wrap bg-quinary">
              <img
                class="d-none d-md-block w-100"
                src="../../assets/payment/trial-to-basic-group.svg"
                alt="First slide"
              />
              <img
                class="d-block d-sm-none w-100"
                src="../../assets/payment/trial-to-basic-group-mobile.svg"
                alt="First slide"
              />
            </div>
            <div class="bg-white text-center shadow-top pt-3">
              <h4 class="text-primary bold">
                {{ labels.segmentByGroupTitle }}
              </h4>
              <p class="line-height m-0 pb-3">
                <small class="bold text-gray03">{{
                  labels.segmentByGroupText1
                }}</small>
                <br />
                <small class="bold text-gray03">{{
                  labels.segmentByGroupText2
                }}</small>
              </p>
            </div>
          </div>
          <div class="carousel-item" :class="{ active: active === 2 }">
            <div class="image-wrap bg-quinary">
              <img
                class="d-none d-md-block w-100"
                src="../../assets/payment/trial-to-basic-custom-poll.svg"
                alt="Second slide"
              />
              <img
                class="d-block d-sm-none w-100"
                src="../../assets/payment/trial-to-basic-custom-poll-mobile.svg"
                alt="Second slide"
              />
            </div>
            <div class="bg-white text-center shadow-top pt-3">
              <h4 class="text-primary bold">{{ labels.customPollTitle }}</h4>
              <p class="line-height m-0 pb-3">
                <small class="bold text-gray03">{{
                  labels.customPollText1
                }}</small>
                <br />
                <small class="bold text-gray03">{{
                  labels.customPollText2
                }}</small>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="controllers">
      <div
        class="slide circle"
        :class="{ active: active === 1 }"
        @click="active = 1"
      ></div>
      <div
        class="slide circle"
        :class="{ active: active === 2 }"
        @click="active = 2"
      ></div>
    </div>
    <div class="text-center pb-3">
      <b-button variant="red02 m-2" @click="goToPlan">{{
        labels.buttonGetEnterprise
      }}</b-button
      ><br />
      <small>
        <b-link class="text-purple05" @click="hide">{{
          labels.linkStayInBasic
        }}</b-link>
      </small>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { notificationDismiss } from '@/service/notification'

export default {
  data() {
    return {
      active: 2,
    }
  },
  computed: {
    ...mapGetters(['resources']),
    labels: function() {
      return this.resources.component.modal.trialToBasic
    },
  },
  mounted() {
    setInterval(this.updateActive, 4000)
  },
  methods: {
    updateActive() {
      this.active = this.active === 1 ? 2 : 1
    },
    open() {
      this.$refs.modal.show()
    },
    onHidden() {
      notificationDismiss(JSON.parse(localStorage.trialToBasic)._id)
    },
    hide() {
      this.$root.$emit('track', {
        data: {
          message: 'Optou por se manter no plano básico',
        },
      })
      this.$refs.modal.hide()
    },
    goToPlan() {
      this.$root.$emit('track', {
        data: {
          message: 'Clicou no botão "Obter o plano empresarial"',
        },
      })
      this.$router.push({
        name: 'account.licenses',
        params: { period: 'monthly' },
      })
      this.$refs.modal.hide()
    },
    validate(data) {
      localStorage.trialToBasic = JSON.stringify(data)
      return true
    },
  },
}
</script>

<style lang="scss">
@import '~@/styles/custom/colors';

.modal-trial-to-basic {
  .modal {
    @media (max-width: 425px) {
      padding-top: 0px;
    }
  }
  .modal-content {
    border-radius: 8px;

    .modal-header {
      border-bottom: 0;

      .modal-title {
        color: white;
      }
    }

    .modal-body {
      padding: 0;

      .carousel-inner {
        .image-wrap {
          padding-left: 1.25rem;
          padding-right: 1.25rem;

          @media (max-width: 425px) {
            padding-left: 0.25rem;
            padding-right: 0.25rem;
          }
          img {
            margin-bottom: -15%;

            @media (max-width: 425px) {
              margin-bottom: -30%;
            }
          }
        }
        .shadow-top {
          box-shadow: rgba(61, 90, 254, 0.16) 0px -6px 6px;
          position: relative;
          z-index: 1;
        }
      }
    }
  }

  .controllers {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: bottom;

    .slide.circle {
      background: map-get($theme-colors, 'purple05');
      border-radius: 10px;
      display: inline-block;
      height: 15px;
      width: 15px;
      margin: 0 4px;

      &.active {
        background: map-get($theme-colors, 'primary');
        height: 16px;
        width: 16px;
        margin: 0 4px;
      }
    }
  }

  .line-height {
    line-height: normal;
  }
}
</style>
